
export enum RaidType {

    RAID_MIRROR = "RAID_MIRROR"

}
